 <div class="d-flex flex-column">
   <div *ngIf="proposal.proposalInformation.insuredSumType" class="d-flex proposal-details-row">
     <div class="info-col">{{'createProposal.housingInsuranceSumType' | translate}}:</div>
     <div>{{'createProposal.housingInsuranceSumTypeOptions.' + proposal.proposalInformation.insuredSumType | translate}}</div>
   </div>
    <div class="d-flex proposal-details-row">
      <div class="info-col">{{'createProposal.insuredAmount' | translate}}:</div>
      <div>
        <ng-container *ngIf="proposal.proposalInformation.insuredSumType === 'VALUES_1914'; else withCurrency">
          {{proposal.proposalInformation.insuredAmount | number: Formats.CURRENCY : localeService.getLocale()}}
        </ng-container>
        <ng-template #withCurrency>
          {{proposal.proposalInformation.insuredAmount | currency:
            proposal.proposalInformation.insuredAmountCurrency: 'symbol': Formats.CURRENCY: localeService.getLocale()}}
        </ng-template>
      </div>
    </div>
   <div *ngIf="proposal.proposalInformation.amountDescription" class="d-flex proposal-details-row">
     <div class="info-col">{{'createProposal.amountDescription' | translate}}:</div>
     <div *ngIf="proposal.proposalInformation.amountDescription!=null">
       {{proposal.proposalInformation.amountDescription}}
     </div>
   </div>
   <div *ngIf="proposal.proposalInformation.annualSalesAmount" class="d-flex proposal-details-row">
     <div class="info-col">{{'createProposal.annualSalesAmount' | translate}}:</div>
     <div>{{proposal.proposalInformation.annualSalesAmount | currency:
       proposal.proposalInformation.insuredAmountCurrency: 'symbol': Formats.CURRENCY: localeService.getLocale()}}</div>
   </div>
   <div *ngIf="proposal.proposalInformation.annualSalesDescription" class="d-flex proposal-details-row">
     <div class="info-col">{{'createProposal.annualSalesDescription' | translate}}:</div>
     <div *ngIf="proposal.proposalInformation.annualSalesDescription!=null">
       {{proposal.proposalInformation.annualSalesDescription}}
     </div>
   </div>
 </div>
